import * as Yup from "yup";
import { XGSSelectOption } from "../../../ui-components/xgs-select/xgsSelect";

export interface ProgramLogsResponseModel {
    eventId: string;       // Unique event ID
    eventTime: string;     // Timestamp of the event
    status: string;        // Status of the event (e.g., "success")
    programHalt: string;   // Indicates if the program halted (e.g., "N")
    eventType: string;     // Type of the event
    eventSource: string;   // Source of the event
    eventDetails: string;  // Description of the event
}

export interface ProgramLogsItemModel {
    page: number;                      // Current page number
    pageSize: number;                  // Number of records per page
    totalRecords: number;              // Total number of records available
    totalPages: number;                // Total number of pages
    extractedResult: ProgramLogsResponseModel[];  // Array of event logs
}

export interface ProgramLogsFilterModel {
    eventId?: string | undefined;
    eventTimeFrom?: string | undefined | null;
    eventTimeTo?: string | undefined | null;
    status?: XGSSelectOption | null | undefined;
    isPgmHalt: boolean | undefined,
    eventType: XGSSelectOption | null | undefined,
    eventSource: XGSSelectOption | null | undefined,
    eventDetails: string | undefined;
};

export interface ProgramLogsTableInfoModel {
    title: string,
    description: string,
    sections: []
}
export const ProgramLogsFilterSchema: Yup.ObjectSchema<ProgramLogsFilterModel> = Yup.object()
    .shape({
        eventId: Yup.string()
            .matches(/^\d+$/, "Only whole numbers are allowed.")
            .min(6, "Document ID must be greater than 100000 or empty."),
        eventTimeFrom: Yup.string()
            .nullable()
            .test("is-valid-from", "Start and end dates must both be provided or left empty.", function (value) {
                const { eventTimeFrom, eventTimeTo } = this.parent;
                return (!eventTimeFrom && !eventTimeTo) || (eventTimeFrom && eventTimeTo) || (eventTimeFrom === null && eventTimeTo === null) || (eventTimeFrom === undefined && eventTimeTo === undefined);
            }),
        eventTimeTo: Yup.string()
            .nullable()
            .test("is-valid-to", "Start and end dates must both be provided or left empty.", function (value) {
                const { eventTimeFrom, eventTimeTo } = this.parent;
                return (!eventTimeFrom && !eventTimeTo) || (eventTimeFrom && eventTimeTo) || (eventTimeFrom === null && eventTimeTo === null) || (eventTimeFrom === undefined && eventTimeTo === undefined);
            }),
        eventDetails: Yup.string().min(1).max(750, "The value must be no more than 750 characters"),
        isPgmHalt: Yup.boolean(),
        status: Yup.object<XGSSelectOption>().optional().nullable()
            .test("status-value", "Status must have a valid value", function (value) {
                return value === null || value === undefined || (value.value !== undefined && value.value !== "");
            }),

        eventType: Yup.object<XGSSelectOption>().optional().nullable()
            .test("eventType-value", "Event type must have a valid value", function (value) {
                return value === null || value === undefined || (value.value !== undefined && value.value !== "");
            }),

        eventSource: Yup.object<XGSSelectOption>().optional().nullable()
            .test("eventSource-value", "Event source must have a valid value", function (value) {
                return value === null || value === undefined || (value.value !== undefined && value.value !== "");
            })
    }).defined()

